// Offline types and interfaces for sync-ready architecture

// Sync status for future sync implementation
export const SyncStatus = {
  SYNCED: 'synced',
  PENDING: 'pending',
  CONFLICT: 'conflict',
  DIRTY: 'dirty',
};

// Cache metadata structure
export const CacheMetadata = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  lastAccessedAt: 'lastAccessedAt',
  cacheKey: 'cacheKey',
  entityType: 'entityType',
};

// Base entity with sync fields for future sync support
export const BaseEntity = {
  id: 'id',
  updatedAt: 'updatedAt',
  lastSyncedAt: 'lastSyncedAt',
  localUpdatedAt: 'localUpdatedAt',
  syncStatus: 'syncStatus',
  deletedLocally: 'deletedLocally',
};

// Cache entry structure
export const CacheEntry = {
  key: 'key',
  data: 'data',
  metadata: 'metadata',
  compressed: 'compressed',
};

// Image cache entry
export const ImageCacheEntry = {
  url: 'url',
  blob: 'blob',
  metadata: 'metadata',
  hash: 'hash',
};

// Queued mutation for future sync
export const QueuedMutation = {
  id: 'id',
  operation: 'operation', // CREATE, UPDATE, DELETE
  entityType: 'entityType',
  entityId: 'entityId',
  payload: 'payload',
  timestamp: 'timestamp',
  retryCount: 'retryCount',
  status: 'status', // PENDING, RETRYING, FAILED
};

// Network status
export const NetworkStatus = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  DEGRADED: 'degraded',
  UNKNOWN: 'unknown',
};

// Cache policy
export const CachePolicy = {
  CACHE_FIRST: 'cache_first',
  NETWORK_FIRST: 'network_first',
  STALE_WHILE_REVALIDATE: 'stale_while_revalidate',
  NETWORK_ONLY: 'network_only',
  CACHE_ONLY: 'cache_only',
};
